import React from 'react';

const Programs: React.FC = () => {
  return (
    <div className="container-fluid program py-5">
      <div className="container py-5">
        <div className="mx-auto text-center wow fadeIn" data-wow-delay="0.1s" style={{ maxWidth: '700px' }}>
          <h4 className="text-primary mb-4 border-bottom border-primary border-2 d-inline-block p-2 title-border-radius">Chương trình giảng dạy</h4>
          <h1 className="mb-5 display-5">Phát Triển Năng Lực Tiếng Anh Với Giáo Trình Cambridge</h1>
        </div>
        <div className="row g-5 justify-content-center">
          <div className="col-md-6 col-lg-6 col-xl-4 wow fadeIn" data-wow-delay="0.1s">
            <div className="program-item rounded">
              <div className="program-img position-relative">
                <div className="overflow-hidden img-border-radius">
                  <img src={process.env.PUBLIC_URL + '/img/program-1.avif'} className="img-fluid w-100" alt="Jumping Class" />
                </div>
              </div>
              <div className="program-text bg-white px-4 pb-3">
                <div className="program-text-inner">
                  <a href="#" className="h4">Lớp Jumping</a>
                  <p className="mt-3 mb-0">Cho trẻ từ 4 - 6 tuổi</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-4 wow fadeIn" data-wow-delay="0.3s">
            <div className="program-item rounded">
              <div className="program-img position-relative">
                <div className="overflow-hidden img-border-radius">
                  <img src={process.env.PUBLIC_URL + '/img/program-2.avif'} className="img-fluid w-100" alt="Pre-CK Class" />
                </div>
              </div>
              <div className="program-text bg-white px-4 pb-3">
                <div className="program-text-inner">
                  <a href="#" className="h4">Lớp Pre-CK</a>
                  <p className="mt-3 mb-0">Cho học viên từ 7 - 14 tuổi</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Programs; 